/** The new-submission form, the check report and the submission detail page (plan E). */
export default {
  form: {
    emailNotice:
      'The council may email you updates about this application. You can turn them off under Email preferences on the submissions list.',
    title: 'New submission',
    back: 'Back to submissions',
    notAllowed: 'You cannot create submissions. Ask an administrator to add you to a reviewer or approver group.',
    sectionSubmission: 'Submission',
    sectionDrawing: 'Drawing',
    sectionAttributes: 'Plan details',
    sectionApplicant: 'Applicant',
    titleLabel: 'Project name',
    profileLabel: 'Plan type',
    crsLabel: 'Coordinate system',
    choose: 'Choose…',
    fileLabel: 'CAD drawing (.dwg or .dxf)',
    fileHint: 'Up to {{max}} MB. DWG from AutoCAD 2000 to 2018, or DXF.',
    fileChosen: '{{name}} ({{size}})',
    applicantName: 'Applicant name',
    applicantFirm: 'Firm',
    applicantEmail: 'Email',
    applicantRegNo: 'Professional registration number',
    submit: 'Submit for checking',
    retry: 'Try again',
    cancelUpload: 'Cancel upload',
    draftCreated: 'Draft {{caseRef}} was created. Its details are locked; Try again resumes from the upload.',
    openSubmission: 'Open submission',
    pollTimeout: 'The check is taking longer than expected. Open the submission to follow it.',
    errors: {
      required: 'Required.',
      notANumber: 'Enter a number.',
      notAYear: 'Enter a four-digit year.',
      email: 'Enter a valid email address.',
      fileMissing: 'Choose a drawing to upload.',
      fileType: 'Choose a .dwg or .dxf file.',
      fileEmpty: 'The file is empty.',
      fileTooLarge: 'The file is larger than {{max}} MB.',
    },
    phase: {
      creating: 'Creating the submission…',
      uploading: 'Uploading the drawing… {{percent}}%',
      finalizing: 'Checking the upload…',
      submitting: 'Submitting…',
      checking: 'Converting and checking the drawing…',
    },
  },
  report: {
    title: 'Check report',
    pending: 'The drawing is still being checked ({{status}}).',
    errored: 'The check could not run. A reviewer can retry it.',
    none: 'No check has run for this revision yet.',
    zoomTo: 'Zoom to',
    areas: 'Areas',
    siteArea: 'Site area',
    declaredArea: 'Declared area',
    byClass: 'By land use',
    classColumn: 'Land use',
    areaColumn: 'Area',
    plotsColumn: 'Plots',
    unclassified: 'Unclassified',
    noFindings: 'No findings.',
    landingTitle: 'Where did my drawing land?',
    landingHint:
      'The dot is the centre of your site, read in the coordinate system you declared. The outlined shape is the area the council set.',
    revision: 'Revision {{revision}}',
  },
  detail: {
    back: 'Back to submissions',
    revision: 'Revision {{revision}}',
    applicant: 'Applicant',
    attributes: 'Details',
    profile: 'Plan type',
    crs: 'Coordinate system',
    map: 'Map preview',
    revisions: 'Revisions',
    timeline: 'Timeline',
    actions: 'Actions',
    noActions: 'No actions are available to you at this stage.',
    viewReport: 'View report',
    reportMissing: 'The check report could not be loaded.',
    replayed: 'That action had already been applied.',
    done: 'Done.',
    notFound: 'This submission does not exist or you cannot see it.',
    disabledBecause: 'Not available: {{reasons}}',
    columns: {
      revision: 'Revision',
      file: 'File',
      status: 'Check',
      finished: 'Finished',
    },
  },
} as const
